import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotFoundComponent} from "./shared/not-found/not-found.component";
import {HomeResolverService} from "./services/home-resolver.service";
import {PageLayout} from "./enums/page-layout";
import {AuthGuardWithForcedLogin} from "./auth/auth-guard-with-forced-login.service";
import {environment} from "../environments/environment";
// import {canActivate} from "./services/auth-guard.service";

const routes: Routes = [
  {
    path: 'berufe',
    loadChildren: () => import('./professions/professions.module').then(m => m.ProfessionsModule),
    data: {
      breadcrumb: 'Berufe',
      title: "Berufe"
    }
  },
  {
    path: 'jobboerse',
    loadChildren: () => import('./jobs/jobs.module').then(m => m.JobsModule),
    data: {
      breadcrumb: 'Jobs',
      title: "Jobs"
    }
  },
  {
    path: 'anbieter',
    loadChildren: () => import('./providers/providers.module').then(m => m.ProvidersModule),
    data: {
      breadcrumb: 'Anbieter',
      title: "Anbieter"
    }
  },
  {
    path: 'angebote',
    loadChildren: () => import('./events/events.module').then(m => m.EventsModule),
    data: {
      breadcrumb: 'Angebote',
      title: "Angebote"
    }
  },
  {
    path: 'infos-angebote',
    loadChildren: () => import('./infos-offers/infos-offers.module').then(m => m.InfosOffersModule),
    data: {
      breadcrumb: {
        skip: true,
        label: 'Infos',
        disable: true
      },
      title: "Infos",
      layout: PageLayout.SIDE
    }
  },

  {
    path: 'angebote-fuer-lehrpersonen',
    loadChildren: () => import('./events/events.module').then(m => m.EventsModule),
    data: {
      breadcrumb: {
        label: 'Angebote für Lehrpersonen',
        disable: true
      },
      title: "Angebote für Lehrpersonen",
      layout: PageLayout.SIDE
    }
  },
  {
    path: 'einblicke',
    loadChildren: () => import('./insights/insights.module').then(m => m.InsightsModule),
    data: {
      breadcrumb: 'Einblicke',
      title: "Einblicke"
    }
  },
  {
    path: 'gewinnspiel', // welcomeMessageService use this path
    loadChildren: () => import('./game-info-page/game-info-page.module').then(m => m.GameInfoPageModule),
    data: {
      breadcrumb: 'Gewinnspiel',
      title: "Gewinnspiel"
    }
  },
  {
    path: 'berufe-vergleichen',
    loadChildren: () => import('./compare-professions/compare-professions.module').then(m => m.CompareProfessionsModule),
    data: {
      breadcrumb: {
        label: 'Berufe Vergleichen'
      },
      title: "Berufe Vergleichen"
    }
  },
  {
    path: 'merkliste',
    loadChildren: () => import('./favorites/favorites.module').then(m => m.FavoritesModule),
    data: {
      breadcrumb: 'Merkliste',
      title: "Merkliste"
    }
  },
  {
    path: 'selbst-test',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  {
    path: 'impressum',
    loadChildren: () => import('./simple-page/simple-page.module').then(m => m.SimplePageModule),
    data: {
      breadcrumb: 'Impressum',
      page: 'imprint',
      title: "Impressum"
    }
  },
  {
    path: 'datenschutz',
    loadChildren: () => import('./simple-page/simple-page.module').then(m => m.SimplePageModule),
    data: {
      breadcrumb: 'Datenschutz',
      page: 'data-protection',
      title: "Datenschutz"
    }
  },
  {
    path: 'barrierefreiheit',
    loadChildren: () => import('./simple-page/simple-page.module').then(m => m.SimplePageModule),
    data: {
      breadcrumb: 'Barrierefreiheit',
      page: 'accessibility',
      title: "Barrierefreiheit"
    }
  },
  {
    path: 'nutzungsbedingungen',
    loadChildren: () => import('./simple-page/simple-page.module').then(m => m.SimplePageModule),
    data: {
      breadcrumb: 'Nutzungsbedingungen',
      page: 'terms-conditions',
      title: "Nutzungsbedingungen"
    }
  },
  {
    path: 'cookieeinstellungen',
    loadChildren: () => import('./simple-page/simple-page.module').then(m => m.SimplePageModule),
    data: {
      breadcrumb: 'Cookieeinstellungen',
      page: 'cookie-settings',
      title: "Cookieeinstellungen"
    }
  },
  {
    path: 'about',
    loadChildren: () => import('./simple-page/simple-page.module').then(m => m.SimplePageModule),
    data: {
      breadcrumb: 'berufsreise',
      page: 'about',
      title: "Über Berufsreise"
    }
  },
  {
    path: 'code-generator',
    loadChildren: () => import('./code-generator/code-generator.module').then(m => m.CodeGeneratorModule),
    data: {
      breadcrumb: 'berufsreise',
      page: 'about',
      title: "Über Berufsreise"
    }
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    data: {
      breadcrumb: 'Start'
    }
  },
  {
    path: 'oauthlogin',
    loadChildren: () => import('./login-router/login-router.module').then(m => m.LoginRouterModule),
    data: {
      breadcrumb: 'Start'
    }
  },
  {
    path: 'klasse',
    loadChildren: () => import('./school-class/school-class.module').then(m => m.SchoolClassModule),
    data: {
      breadcrumb: 'Klasse',
      layout: PageLayout.DEFAULT
    }
  },
  {
    path: 'rookie',
    loadChildren: () => import('./rookie/rookie.module').then(m => m.RookieModule),
    data: {
      // "Start" for the rookie breadcrumb, pointing at /rookie (not the global "/" root,
      // which RookieComponent hides while in this area).
      breadcrumb: 'Start',
      layout: PageLayout.ROOKIE,
      title: "Rookie – Schüler*innen in Betrieben | Rookie"
    }
  },
  {
    path: 'rookieday',
    loadChildren: () => import('./rookieday/rookieday.module').then(m => m.RookieDayModule),
    data: {
      // "Start" for the rookieday breadcrumb, pointing at /rookieday (not the global "/" root,
      // which RookieDayComponent hides while in this area).
      breadcrumb: 'Start',
      layout: PageLayout.ROOKIE,
      title: "RookieDay"
    }
  },
  {
    path: 'lehrer',
    loadChildren: () => import('./teacher/teacher.module').then(m => m.TeacherModule),
    data: {
      breadcrumb: {
        label: 'Dashboard'
      },
      layout: PageLayout.SIDE
    },
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'provider',
    loadChildren: () => import('./provider-settings/provider-settings.module').then(m => m.ProviderSettingsModule),
    data: {
      breadcrumb: 'Dashboard',
      layout: PageLayout.SIDE
    },
    // canActivate: [providerSettingsGuard]
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'private',
    pathMatch: "full",
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    resolve: {
      apiData: HomeResolverService
    },
    data: {
      breadcrumb: 'Start'
    },
    // canActivate: [canActivate]
  },
  {
    path: 'registrierung',
    pathMatch: "full",
    loadChildren: () => import('./sign-up/sign-up.module').then(m => m.SignUpModule),
    resolve: {
    },
    data: {
      breadcrumb: 'Registrieren'
    },
    // canActivate: [canActivate]
  },
  {
    // public page, reachable only via the token link sent to the company
    path: 'vorschlag-unternehmensprofil',
    loadChildren: () => import('./company-profile-suggestion/company-profile-suggestion.module').then(m => m.CompanyProfileSuggestionModule),
    data: {
      breadcrumb: 'Unternehmensprofil',
      title: 'Unternehmensprofil prüfen'
    }
  },
  // Development sandbox for the rich text editor. Not linked from any menu;
  // reachable only by typing the route and only if enabled in the environment.
  ...(environment.enableEditorSandbox ? [{
    path: 'editor-sandbox',
    loadChildren: () => import('./editor-sandbox/editor-sandbox.module').then(m => m.EditorSandboxModule),
    data: {
      breadcrumb: 'Editor-Sandbox',
      title: 'Editor-Sandbox'
    }
  }] : []),
  {
    path: '',
    pathMatch: "full",
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    resolve: {
      apiData: HomeResolverService
    },
    data: {
      breadcrumb: 'Start'
    }
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: {
      breadcrumb: '404 – Seite nicht gefunden',
      notFound: 'true',
      title: "404 – Seite nicht gefunden",
      layout: PageLayout.NOT_FOUND
    }
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'disabled',
    anchorScrolling: "enabled"
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
